import React, { useState, useEffect, useCallback } from 'react';
import { useParams } from 'react-router-dom';
import { fetchBooks } from '../utils/bookService';
import { getAuth } from 'firebase/auth';
import Navigation from './Navigation';
import '../css/Book.css';

const Book = () => {
    const { isbn } = useParams();
    const [book, setBook] = useState(null);
    const [loading, setLoading] = useState(true);
    const auth = getAuth();

    const formatDate = useCallback((dateString) => {
        if (!dateString) return 'Unknown';
        try {
            const date = new Date(dateString);
            return date.toLocaleDateString('en-US', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
            });
        } catch (error) {
            return dateString;
        }
    }, []);

    useEffect(() => {
        let isMounted = true;

        const fetchBookDetails = async () => {
            if (!isbn) return;

            try {
                const results = await fetchBooks(`q=isbn:${isbn}`, auth.currentUser?.uid);
                if (isMounted && results && results.length > 0) {
                    setBook(results[0]);
                }
            } finally {
                if (isMounted) {
                    setLoading(false);
                }
            }
        };

        fetchBookDetails();

        return () => {
            isMounted = false;
        };
    }, [isbn, auth.currentUser]);

    if (loading) {
        return (
            <div className="book-page">
                <Navigation />
                <div className="loading-spinner">Loading...</div>
            </div>
        );
    }

    if (!book) {
        return (
            <div className="book-page">
                <Navigation />
                <div className="book-card">
                    <h2>Book not found</h2>
                </div>
            </div>
        );
    }

    const { volumeInfo } = book;
    const { title, authors, publishedDate, releaseDate, description, publisher, pageCount, categories, language, imageLinks } = volumeInfo;

    return (
        <div className="book-page">
            <Navigation />
            <div className="book-card">
                <div className="book-header">
                    <img 
                        src={imageLinks?.thumbnail || 'placeholder-image.jpg'} 
                        alt={title}
                        className="book-cover"
                    />
                    <div className="book-info">
                        <h2>{title}</h2>
                        <p className="authors">{authors?.join(', ')}</p>
                        <p className="published-date">
                            <strong>Published:</strong> {formatDate(publishedDate)}
                            {releaseDate && (
                                <span className="release-date">
                                    <br />
                                    <strong>Released:</strong> {formatDate(releaseDate)}
                                </span>
                            )}
                        </p>
                    </div>
                </div>

                <div className="book-details">
                    <h3>Description</h3>
                    <p>{description || 'No description available.'}</p>

                    <h3>Details</h3>
                    <ul>
                        <li><strong>Publisher:</strong> {publisher || 'Unknown'}</li>
                        <li><strong>Page Count:</strong> {pageCount || 'Unknown'}</li>
                        <li><strong>Categories:</strong> {categories?.join(', ') || 'Unknown'}</li>
                        <li><strong>Language:</strong> {language || 'Unknown'}</li>
                    </ul>
                </div>
            </div>
        </div>
    );
};

export default Book;